import { RestSlice } from '../../../../redux/rest.slice';
import { Dataset } from '@rcp/types';
import { localizationService, Resource } from 'src/services';

export const settingLookupsDataSetSlice = new RestSlice<Dataset>(
	localizationService.getLocalizedString('cccSettings.lookupDatasets'),
	Resource.SettingLookup + '/DataSets'
);
export default settingLookupsDataSetSlice.rests.reducer;
